import { TApplicationState } from '../../types/referral/store';

export const selectRegionsList = (state: TApplicationState) => state.form.regionsList;
